import { createContext } from 'react';
import type { Texts } from './types';

type TextsContext = {
  texts: Texts | undefined;
};

export default createContext<TextsContext>({
  texts: undefined,
});
